import { render, staticRenderFns } from "./CompanyPage.vue?vue&type=template&id=0581b562&scoped=true"
import script from "./CompanyPage.vue?vue&type=script&lang=js"
export * from "./CompanyPage.vue?vue&type=script&lang=js"
import style0 from "./CompanyPage.vue?vue&type=style&index=0&id=0581b562&prod&lang=scss"
import style1 from "./CompanyPage.vue?vue&type=style&index=1&id=0581b562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0581b562",
  null
  
)

export default component.exports